export enum PlatformType {
  WEB = 'Web',
  MOBILE = 'Mobile',
}

export type PlatformProps = {
  platformType: PlatformType;
};
